module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      segment: _vm.route === 'segment'
    },
    style: (_vm.getColorBtn),
    attrs: {
      "id": "editor"
    }
  }, [_c('panel-title-pages'), _vm._v(" "), _c('panel-fit-screen'), _vm._v(" "), _c('panel-wrapper', {
    attrs: {
      "is-edit-segement": _vm.$route.params.type
    }
  }), _vm._v(" "), _c('grapes-wrapper'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "info-panel"
    }
  }, [_c('br'), _vm._v(" "), _c('image', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "img/logo-emp.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.$route.name !== 'segment' && _vm.$route.name !== 'EditSegment') ? _c('save') : _vm._e(), _vm._v(" "), _c('save-template'), _vm._v(" "), _c('setting-component'), _vm._v(" "), _c('module-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModule || _vm.FromAddSegment),
      expression: "showModule || FromAddSegment"
    }]
  }), _vm._v(" "), _c('add-screen', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddScreen),
      expression: "showAddScreen"
    }]
  }), _vm._v(" "), _c('segment-list'), _vm._v(" "), _c('editor-image-component'), _vm._v(" "), _c('editor-svg-mator-component'), _vm._v(" "), _c('div', {
    staticClass: "test",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "list_videos"
    }
  }, [(_vm.showListVideo) ? _c('list-generic-video', {
    attrs: {
      "genericType": _vm.genericType
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "progress",
    attrs: {
      "id": "progress"
    }
  }, [_c('vue-progress-bar')], 1), _vm._v(" "), _c('informations'), _vm._v(" "), _c('informations-new'), _vm._v(" "), _c('add-generic'), _vm._v(" "), _c('exit-save'), _vm._v(" "), _c('extend-segment-duration')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-panel-label"
  }, [_c('b'), _vm._v(" Aujourd’hui, empreinte.com est le leader français indépendant. Sa clientèle,\n      composée de grands comptes est pérenne (100% de réabonnement). Depuis 2015 empreinte a connu\n      une croissance de +60%. En 2017, la société reçoit une aide BPI innovation de 100 K€ et\n      réalise 1 M€ CA avec 575 K€ de fonds propres. En 2018 elle obtient la note H3 de la Banque\n      de France.\n\n      "), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "info-erreur"
    }
  }, [_c('div', {
    staticClass: "info-panel-label"
  }, [_c('b'), _vm._v(" distributes a complete line of video solution:\n\n      "), _c('br'), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34a3a16c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editor.vue
// module id = 826
// module chunks = 1 3